import React, { useEffect, useState } from "react";
import { useWebLLM } from "../singles/WebLLMContext";

export default function ArticleSummaryLocal({ slug, text }) {
  const { ready, error, summarize } = useWebLLM();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      const key = `summary:${slug}`;
      const cached = localStorage.getItem(key);
      if (cached) { setData(JSON.parse(cached)); return; }

      if (!ready || error) return; // engine not ready yet
      if (!text || text.length < 50) return;

      setLoading(true);
      try {
        const res = await summarize(text);
        setData(res);
        localStorage.setItem(key, JSON.stringify(res));
      } catch (e) {
        console.error("[ArticleSummaryLocal] summarize error:", e);
      } finally {
        setLoading(false);
      }
    })();
  }, [slug, text, ready, error, summarize]);

  if (error && error.includes("WebGPU")) {
    return (
      <aside className="rounded-2xl border p-4 md:p-6 shadow-sm bg-white">
        <div className="text-xs uppercase tracking-wide text-gray-500 mb-2">What you’ll get</div>
        <p className="text-sm text-gray-600">Summary unavailable (WebGPU not supported).</p>
      </aside>
    );
  }

  if (!ready && !data) {
    return <div className="summary-ai rounded-xl p-4 border animate-pulse">Loading on-device model…</div>;
  }
  if (loading) return <div className="summary-ai rounded-xl p-4 border animate-pulse">Generating summary…</div>;
  if (!data) return null;

  return (
    <aside className="rounded-2xl border p-4 md:p-6 shadow-sm bg-white">
      <div className="text-xs uppercase tracking-wide text-gray-500 mb-2">What you’ll get</div>
      <p className="text-base md:text-lg font-medium mb-3">{data.tldr}</p>
      {Array.isArray(data.key_takeaways) && data.key_takeaways.length > 0 && (
        <ul className="list-disc pl-5 space-y-1 text-sm md:text-[15px]">
          {data.key_takeaways.map((k, i) => <li key={i}>{k}</li>)}
        </ul>
      )}
      <div className="mt-4 text-xs text-gray-600 flex gap-4 flex-wrap">
        <span><strong>Audience:</strong> {data.audience}</span>
        <span><strong>Prereqs:</strong> {data.prereqs}</span>
        <span><strong>Read:</strong> ~{data.read_minutes} min</span>
      </div>
    </aside>
  );
}
